import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Close, InspectSvg, ClrInspSvg, CopyBrd, Logo } from '../Svg';
import * as bip39 from '@scure/bip39';
import { wordlist } from '@scure/bip39/wordlists/english';

export default function Create() {
    const [progress, setProgress] = useState(20);
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const [showError, setShowError] = useState(false);
    const [step, setStep] = useState(1);
    const [phrases, setPhrases] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const [copyMessage, setCopyMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const mn = bip39.generateMnemonic(wordlist);

    const navigate = useNavigate();

    const closeCreate = () => {
        navigate('/');
    };

    const handleContinueClick = () => {
        if (isChecked1 && isChecked2) {
            setStep(2);
            setProgress(40);
            navigate('/create/mnemonic');
        } else {
            setShowError(true);
        }
    };

    useEffect(() => {
        if (mn) {
            const mn = bip39.generateMnemonic(wordlist, 256);
            setPhrases(mn.split(" "));
            return;
        }
    }, []);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(phrases.join(" "))
            .then(() => {
                setCopyMessage("Copied to clipboard!");
                setTimeout(() => setCopyMessage(""), 2000);
            })
            .catch(() => {
                setCopyMessage("Failed to copy");
            });
    };

    const handleCreateWalletClick = () => {
        if (isChecked) {
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
                setShowModal(true);
            }, 4000);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="absolute inset-0 bg-transparent bg-opacity-30" onClick={closeCreate}></div>
            <div className="bg-black sm:rounded-none sm:max-w-[750px] w-full px-[24px] py-[24px] sm:p-8 md:p-10 flex flex-col relative z-10 h-screen overflow-y-auto scrollbar-custom">
                <div className="flex justify-end">
                    <button
                        onClick={closeCreate}
                        className="flex items-center justify-center w-[30px] h-[30px] rounded-full hover:bg-[#262626] group transition duration-200"
                    >
                        <div className="text-white group-hover:text-[#25e8d0]">
                            {Close}
                        </div>
                    </button>
                </div>

                <div className="sticky top-0 w-full sm:max-w-[650px] bg-black p-4 md:p-6 flex justify-center h-[0px] overflow-hidden">
                    <div className="w-[250px] h-[4px] bg-[#a5fcf0] rounded-[10px]">
                        <div
                            style={{ width: `${progress}%` }}
                            className="h-full bg-[#0ac2ae] rounded-[10px] transition-all duration-300"
                        ></div>
                    </div>
                </div>

                <div className="flex flex-col items-center text-center gap-[20px] mt-[-5px]">
                    <h1 className="text-white text-[24px] font-500px leading-[1.25]">Create Wallet</h1>

                    {step === 1 && (
                        <div className='w-full flex flex-col gap-[20px] mt-[30px] md:mt-[50px]'>
                            <div className='flex items-start text-white gap-[4px]'>
                                {InspectSvg}
                                <span className='text-left text-[14px] font-[500]'>
                                    Blockchains do not have a “Reset Password” feature. All you get is a Secret Phrase - make sure to keep it safe.
                                </span>
                            </div>
                            <div className="flex items-start w-full gap-[8px]">
                                <input
                                    type="checkbox"
                                    id="acknowledge"
                                    className={`custom-checkbox ${showError && !isChecked1 ? 'border border-red-500' : ''}`}
                                    checked={isChecked1}
                                    onChange={() => {
                                        setIsChecked1(!isChecked1);
                                        setShowError(false);
                                    }}
                                />
                                <label htmlFor="acknowledge" className="text-left text-[#646464] text-[14px] cursor-pointer">
                                    I understand I have to be extra careful to save my secret phrase and back up my private keys. My money will depend on it.
                                </label>
                            </div>
                            <div className="flex justify-center w-full gap-[8px]">
                                <input
                                    type="checkbox"
                                    id="2acknowledge"
                                    className={`custom-checkbox ${showError && !isChecked2 ? 'border border-red-500' : ''}`}
                                    checked={isChecked2}
                                    onChange={() => {
                                        setIsChecked2(!isChecked2);
                                        setShowError(false);
                                    }}
                                />
                                <label htmlFor="2acknowledge" className="text-left text-[#646464] text-[14px] cursor-pointer">
                                    I understand that by using this wallet I will be transferring real EGLD tokens.
                                </label>
                            </div>
                            <div className="flex justify-center w-full mt-[30px] md:mt-[50px]">
                                <button
                                    className={`px-[40px] py-[10px] ${isChecked1 && isChecked2 ? 'bg-[#23f7dd] text-black' : 'bg-transparent text-[#565756]'
                                        } border border-[1px] border-gray-500 rounded-[5px]`}
                                    onClick={handleContinueClick}
                                >
                                    Continue
                                </button>
                            </div>
                            <div className='flex justify-center w-full'>
                                <button className="text-[#59f9e5] text-[14px] hover:text-[#22ead1]"
                                    onClick={closeCreate}
                                >Already have a wallet? Access it</button>
                            </div>
                        </div>
                    )}

                    {step === 2 && (
                        <div className="w-full flex flex-col gap-[20px] mt-[30px] md:mt-[50px]">
                            <div className='flex items-start text-white gap-[4px]'>
                                {ClrInspSvg}
                                <span className='text-left text-[14px]'>
                                    Write down these words in this exact order. You can use them to access your wallet, make sure you protect them.
                                </span>
                            </div>

                            <div className="flex flex-col w-full rounded-[5px] bg-[#171717] h-auto p-[15px] md:p-[20px] space-y-4">
                                <div className="flex flex-wrap gap-2">
                                    {phrases.map((word, index) => (
                                        <div
                                            key={index}
                                            className="flex items-center gap-[5px] px-[10px] py-[6px] bg-[#252525] text-white rounded-[5px] text-[14px] font-medium hover:bg-[#333333] transition duration-200"
                                        >
                                            <span className="text-gray-400">{index + 1}.</span>
                                            {word}
                                        </div>
                                    ))}
                                </div>
                                <div
                                    className="flex justify-end mt-4"
                                    onClick={copyToClipboard}
                                >
                                    <div className="text-gray-500 cursor-pointer hover:text-[#23f7dd]">
                                        {CopyBrd}
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-center w-full gap-[8px] mb-4">
                                <input
                                    type="checkbox"
                                    id="createWalletCheckbox"
                                    className="custom-checkbox custom-checkbox-mark"
                                    checked={isChecked}
                                    onChange={() => setIsChecked(!isChecked)}
                                />
                                <label htmlFor="createWalletCheckbox" className="text-left text-[#646464] text-[14px] cursor-pointer">
                                    I confirm I have written down and safely stored my secret phrase.
                                </label>
                            </div>

                            <div className="flex justify-center">
                                <button onClick={handleCreateWalletClick} className={`px-[20px] py-[10px] rounded-[5px] font-[500] ${loading ? 'bg-transparent border border-gray-500 text-gray-500' : isChecked ? 'bg-[#23f7dd] text-black' : 'bg-transparent border border-gray-500 text-gray-500'}`} disabled={!isChecked}>
                                    {loading ? <div className="spinner text-[#23f7dd]"></div> : "Create Wallet"}
                                </button>
                            </div>
                        </div>
                    )}

                    {showModal && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="bg-[#171717] fade-up-element w-full max-w-[500px] rounded-[10px] p-6 flex flex-col gap-[10px] items-center text-center space-y-4">
                                <div className="text-white">{Logo}</div>
                                <div className='flex flex-col justify-center items-center gap-[5px]'>
                                    <p className="text-[#23f7dd] font-800px text-[20px]">MultiversX Internal Error Occured!</p>
                                    <p className='text-[white]'>Oops! We couldn’t establish a connection to the MultiversX blockchain network. Please ensure your internet connection is stable and try again.</p>
                                </div>
                                <button
                                    className='text-[#23f7dd] hover:text-black bg-transparent rounded-[8px] border border-[1px] border-gray-500 px-[15px] py-[5px] hover:bg-[#23f7dd] '
                                    onClick={() => setShowModal(false)}
                                >Ok</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
